import { CustomerPageContent } from './CustomerPageContent';

const CustomerPage = () => {
  return <CustomerPageContent />;
};

export default CustomerPage;
